/* tslint:disable */
/* eslint-disable */
/**
 * Disponent.Online
 * Disponent.Online API
 *
 * The version of the OpenAPI document: 0.1
 * Contact: service@weberdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AuftragDefaultSpezService } from '../models';
// @ts-ignore
import { Message } from '../models';
/**
 * ServiceService - axios parameter creator
 * @export
 */
export const ServiceServiceAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Liefert eine Liste von DefaultServices (Auftragsspezifikationen im DPlus)
         * @summary AuftragService
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultAuftragServices: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auftragdefaultservice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServiceService - functional programming interface
 * @export
 */
export const ServiceServiceFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ServiceServiceAxiosParamCreator(configuration)
    return {
        /**
         * Liefert eine Liste von DefaultServices (Auftragsspezifikationen im DPlus)
         * @summary AuftragService
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDefaultAuftragServices(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuftragDefaultSpezService>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDefaultAuftragServices(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ServiceService - factory interface
 * @export
 */
export const ServiceServiceFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ServiceServiceFp(configuration)
    return {
        /**
         * Liefert eine Liste von DefaultServices (Auftragsspezifikationen im DPlus)
         * @summary AuftragService
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultAuftragServices(options?: any): AxiosPromise<Array<AuftragDefaultSpezService>> {
            return localVarFp.getDefaultAuftragServices(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ServiceService - interface
 * @export
 * @interface ServiceService
 */
export interface ServiceServiceInterface {
    /**
     * Liefert eine Liste von DefaultServices (Auftragsspezifikationen im DPlus)
     * @summary AuftragService
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceServiceInterface
     */
    getDefaultAuftragServices(options?: any): AxiosPromise<Array<AuftragDefaultSpezService>>;

}

/**
 * ServiceService - object-oriented interface
 * @export
 * @class ServiceService
 * @extends {BaseAPI}
 */
export class ServiceService extends BaseAPI implements ServiceServiceInterface {
    /**
     * Liefert eine Liste von DefaultServices (Auftragsspezifikationen im DPlus)
     * @summary AuftragService
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceService
     */
    public getDefaultAuftragServices(options?: any) {
        return ServiceServiceFp(this.configuration).getDefaultAuftragServices(options).then((request) => request(this.axios, this.basePath));
    }
}
